import React from 'react';
import { useTranslation } from 'react-i18next';


import { makeStyles } from 'tss-react/mui';
import { ErrorInfo, Grid, KeyValue, Typography } from 'web-library';

const useStyles = makeStyles()((theme) =>
({
  errorContainer: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pendingLabel: {
    marginBottom: theme.spacing(2),
  },
}));

interface ExamDraftApplicationProps {
  displayExamType?: string;
  examLevels?: string[];
  applicationId?: string;
  examYear?: number;
  examType?: string;
}

const ExamDraftApplication = ({
  examLevels = undefined,
  applicationId = undefined,
  examYear = 0,
  examType = undefined,
  displayExamType = undefined,
}: ExamDraftApplicationProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const errorLabel =
    displayExamType !== examType
      ? t('exam->>RegisterExamInstructions.You have an existing draft application.')
      : '';

  const displayExamLevels = examLevels?.length
    ? examLevels.map((item) => `${item}`).join(', ')
    : '-';

  if (errorLabel) {
    return (
      <Grid xs={12} className={classes.errorContainer}>
        <ErrorInfo label={errorLabel} />
      </Grid>
    );
  }

  return (
    <>
      <Typography variant="body1" className={classes.pendingLabel}>
        {t('exam->>RegisterExamInstructions.FollowingRegistrationPendingCompletion')}
      </Typography>
      <Grid>
        <KeyValue
          id="applicationId"
          keyText={t('exam->>RegisterExamInstructions.Application No')}
          valueText={applicationId}
        />
      </Grid>
      <Grid>
        <KeyValue
          id="examLevel"
          keyText={t('exam->>RegisterExamInstructions.Exam Level(s)')}
          valueText={displayExamLevels}
          capitalize={false}
        />
      </Grid>
    </>
  );
};
export default ExamDraftApplication;
